/**
 * PasoConclusiones — Paso 5 del IS. Lista editable de cadenas
 * (conclusionesRecomendaciones); un textarea por ítem, con agregar/quitar.
 *
 * Nota: todo IS (nuevo o continuación IE→IS) arranca con las 4 conclusiones
 * fijas del template oficial (CONCLUSIONES_IS_DEFAULT en is-payload.ts). El
 * técnico puede editarlas, borrarlas o agregar propias.
 */
import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/shared/ui/button.js";
import { LabeledTextarea, labelClass } from "../ie/fields.js";

export function PasoConclusiones(props: {
  value: string[];
  onChange: (next: string[]) => void;
  disabled?: boolean;
}) {
  const { value, onChange, disabled } = props;

  function agregar() {
    onChange([...value, ""]);
  }

  function quitar(index: number) {
    onChange(value.filter((_, i) => i !== index));
  }

  function set(index: number, v: string) {
    onChange(value.map((c, i) => (i === index ? v : c)));
  }

  return (
    <div className="space-y-4">
      {value.length === 0 ? (
        <p className="text-sm text-muted-foreground">
          Sin conclusiones todavía. Agrega la primera con el botón de abajo.
        </p>
      ) : (
        <ul className="space-y-4">
          {value.map((conclusion, i) => (
            <li key={i} className="space-y-3 rounded-lg border border-border bg-background/60 p-4">
              <div className="flex items-center justify-between">
                <span className={labelClass}>Conclusión {i + 1}</span>
                <Button
                  type="button"
                  variant="outline"
                  size="sm"
                  disabled={disabled}
                  onClick={() => quitar(i)}
                  className="gap-1.5 font-mono text-[0.625rem] uppercase tracking-[0.1em] text-destructive"
                >
                  <Trash2 className="size-3.5" aria-hidden />
                  Quitar
                </Button>
              </div>
              <LabeledTextarea
                id={`concl-${i}`}
                label="Texto"
                value={conclusion}
                onChange={(v) => set(i, v)}
                disabled={disabled}
                rows={3}
                placeholder="Conclusión o recomendación"
              />
            </li>
          ))}
        </ul>
      )}

      <Button
        type="button"
        variant="outline"
        size="sm"
        disabled={disabled}
        onClick={agregar}
        className="gap-1.5 font-mono text-[0.625rem] uppercase tracking-[0.12em]"
      >
        <Plus className="size-3.5" aria-hidden />
        Agregar conclusión
      </Button>
    </div>
  );
}
